module.exports = __webpack_public_path__ + "img/subject-18.ce39d2fe.svg";